import AcutameFakeApi from './AcutameFakeApi';
import AcutameApi from './AcutameApi';

export default process.env.VUE_APP_MOCK_ACUTAME_API === 'true'
  ? AcutameFakeApi
  : AcutameApi;
